import produce from 'immer';
import { storage } from '@annunciate/core/dist/store/mmkv-store';
import { messageFactory, Topic, useDownloadStateStore } from '@annunciate/core';
import { PlaybackEventEmitter, PlaybackEvent } from '@annunciate/core';
import DownloadUtils from '../../DownloadUtils';
import { multiKeyMap } from './multiKeyMap';
import { getItemDownloadDirectory } from './getItemDownloadDirectory';
import { DOWNLOAD_CACHE_KEY } from './onSuccessfulDownloadMutateCache';
const { setDownloadDetails, stopAndRemoveTasksForContentId, } = useDownloadStateStore.getState();
export const removeDownloads = async ({ uuid, items, client, }) => {
    if (!uuid) {
        return [];
    }
    const ops = items
        .map(async (item) => {
        const { absolute: directory } = getItemDownloadDirectory(item, uuid);
        try {
            await DownloadUtils.unlink(directory);
        }
        catch (err) {
            console.warn(`Unable to delete download ${item.id}`, err);
        }
        setDownloadDetails(item.id.toString(), { progress: 0 });
        PlaybackEventEmitter.emit(PlaybackEvent.CONTENT_DELETED, item);
        messageFactory(Topic.CONTENT_DOWNLOAD_DELETED, {
            item: {
                type: 'content',
                id: item.id,
            },
        });
    });
    try {
        await Promise.all(ops);
    }
    catch (err) {
        console.error(err);
    }
    const keys = multiKeyMap(DOWNLOAD_CACHE_KEY, uuid, items);
    for (const key of keys) {
        storage.delete(key);
    }
    client.setQueryData([DOWNLOAD_CACHE_KEY], (input) => {
        return produce(input || [], (draft) => {
            const mapById = items.reduce((acc, item) => {
                acc[item.id];
                return acc;
            }, {});
            const filtered = draft.filter((item) => {
                if (mapById[item.id]) {
                    return false;
                }
                ;
                return true;
            });
            return filtered;
        });
    });
    for (const item of items) {
        client.setQueryData([`${DOWNLOAD_CACHE_KEY}:${uuid}`, { id: item.id }], false);
        stopAndRemoveTasksForContentId(item.id.toString());
    }
    return items;
};
//# sourceMappingURL=removeDownloads.js.map